import { Button, Col, Form, Row, Upload } from "antd";
import React, { useEffect, useState } from "react";

import { MdEdit } from "react-icons/md";
import { useTranslation } from "react-i18next";
import { ORGANIZATION } from "@src/helpers/imagesConstants";
import Name from "../my-account-form/Name";
import Mobile from "../my-account-form/Mobile";
import Email from "../my-account-form/Email";
import { useDispatch, useSelector } from "react-redux";
import { retrieveItem } from "@src/helpers/functions";
import {
  AppDispatch,
  getUserList,
  getUserListRequest,
  updateOrganization,
  updateOrganizationRequest } from
"@src/redux";
import {
  action,
  handleBeforeUpload,
  handleFileChanged,
  handleUpload } from
"@src/helpers/fileUpload";
import { useCheckPageComponentAccess } from "@src/hooks/index";

interface mobileObject {
  number?: string;
  country_code?: string;
  country_short_code?: string;
}

const OrganizationDetails: React.FC = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [organizationProfileForm] = Form.useForm();

  const [buttonVisible, setButtonVisible] = useState<boolean>(false);
  const [organizationId, setOrganizationId] = useState<any>("");
  const [mobile, setMobile] = useState<Object>({});
  const dispatch = useDispatch<AppDispatch>();
  const userId = retrieveItem("userId");
  // const organizationId = retrieveItem("organizationId");
  const { result: getUserListResult } = useSelector(getUserList);
  const { result: organizationResult, loading: updateOrganizationLoading } =
  useSelector(updateOrganization);
  const organizationProfile = Form.useWatch(
    "organization_profile",
    organizationProfileForm
  );

  const getUser = () => {
    dispatch(
      getUserListRequest({
        filter: {
          id: userId
        }
      })
    );
  };

  useEffect(() => {
    getUser();
  }, [dispatch]);

  useEffect(() => {
    if (organizationResult?.status === "success") {
      setButtonVisible(false);

      getUser();
    }
  }, [organizationResult]);

  useEffect(() => {
    if (getUserListResult?.items?.length) {
      const users = getUserListResult.items?.[0];
      const countryCode = users?.organization?.mobile?.CountryCode;
      const mobileNum = users?.organization?.mobile?.Number;
      const mobileNumber = countryCode && mobileNum ? `${countryCode}${mobileNum}` : "";
      setOrganizationId(getUserListResult?.items?.[0]?.organization?.id);
      form.setFieldsValue({
        name: users?.organization?.name,
        mobile: mobileNumber,
        email: users?.organization?.email
      });
      setMobile(getUserListResult?.items?.[0]?.mobile || {});
    }
  }, [getUserListResult]);

  const onChangeEdit = () => {
    setButtonVisible(true);
  };

  const onClickCancel = () => {
    setButtonVisible(false);
  };

  const handleChangeNumber = (values: {
    number: string;
    country_code: string;
    country_short_code: string;
  }) => {
    setMobile(values);
  };

  const onFinish = (values: any) => {
    let mobile = values.mobile.split("").slice(3).join("");
    let country_code = values.mobile.split("").slice(0, 3).join("");

    dispatch(
      updateOrganizationRequest({
        id: organizationId,
        data: {
          email: values.email,
          name: values.name,
          mobile: {
            Number: mobile,
            CountryCode: country_code
          },
          logoUrl: organizationProfile?.file?.url
        }
      })
    );
  };

  return (
    <Row className="form-container">
      <Col span={10} className="avatar-container">
        <Form form={organizationProfileForm}>
          <Form.Item name={"organization_profile"}>
            <Upload
              action={action}
              customRequest={(e) => handleUpload(e)}
              beforeUpload={(args) =>
              handleBeforeUpload(args, "logo", ["image/jpg", "image/png"])}

              onChange={(e) => handleFileChanged(e)}
              showUploadList={false}

              // disabled={buttonVisible}
            >
              <div className="user-profile-wrapper">
                <img
                  src={
                  organizationProfile?.file?.url ||
                  getUserListResult?.items?.[0]?.organization?.logoUrl ||
                  ORGANIZATION}

                  className="user_profile_image"
                  alt="User Profile" />
                

                {buttonVisible && <MdEdit className="edit-icon" />}
              </div>
            </Upload>
          </Form.Item>
        </Form>
      </Col>
      <Col span={10}>
        <Form
          layout="horizontal"
          className="profile-form"
          form={form}
          onFinish={onFinish}
          //   onFinish={onFinish}
          labelCol={{
            flex: "110px"
          }}
          labelAlign="left"
          labelWrap
          wrapperCol={{
            flex: 1
          }}
          colon={false}>
          
          <Name visible={buttonVisible} />
          <Mobile visible={buttonVisible} onChange={handleChangeNumber} />
          <Email visible={buttonVisible} />

          {!buttonVisible &&
          useCheckPageComponentAccess("update_organization_details") ?
          <div className="my_account_button_wrapper">
              <Button onClick={onChangeEdit} className="my_account_edit_button">
                {t("act_edit")}
              </Button>
            </div> :

          <div className="my_account_button_wrapper">
              <Form.Item>
                <Button
                type="default"
                className="cancel-btn"
                onClick={onClickCancel}>
                
                  {t("cancel")}
                </Button>
                {useCheckPageComponentAccess("update_organization_details") &&
              <Button
                className="my_account_edit_button"
                htmlType="submit"
                loading={updateOrganizationLoading}>
                
                    {t("submit")}
                  </Button>}
              
              </Form.Item>
            </div>}
          
        </Form>
      </Col>
    </Row>);

};

export default OrganizationDetails;